<template>
  <div>
    <div class="up-input-group">
      <div>
        <up-textinput
          v-model="line_chart.title"
          size="md"
          label="Title"
          labelIcon="mdi mdi-alpha-t-box-outline"
        ></up-textinput>
      </div>
      <div>
        <up-textinput
          v-model="line_chart.x_title"
          size="md"
          label="X-Axis Title"
          labelIcon="mdi mdi-alpha-x-box-outline"
        ></up-textinput>
      </div>
      <div>
        <up-textinput
          v-model="line_chart.y_title"
          size="md"
          label="Y-Axis Title"
          labelIcon="mdi mdi-alpha-y-box-outline"
        ></up-textinput>
      </div>
      <div>
        <up-switch
          v-model="line_chart.is_custom_x_labels"
          size="xs"
          label="Custom X labels"
        ></up-switch>
      </div>
      <div v-if="!line_chart.is_custom_x_labels">
        <up-numberinput
          v-model="line_chart.min_x_value"
          size="xs"
          label="Min Value(X-Axis)"
          labelIcon="mdi mdi-alpha-x-box-outline"
        ></up-numberinput>
      </div>
      <div v-if="!line_chart.is_custom_x_labels">
        <up-numberinput
          v-model="line_chart.max_x_value"
          size="xs"
          label="Max Value(X-Axis)"
          labelIcon="mdi mdi-alpha-x-box-outline"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          v-model="line_chart.min_y_value"
          size="xs"
          label="Min Value(Y-Axis)"
          labelIcon="mdi mdi-alpha-y-box-outline"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          v-model="line_chart.max_y_value"
          size="xs"
          label="Max Value(Y-Axis)"
          labelIcon="mdi mdi-alpha-y-box-outline"
        ></up-numberinput>
      </div>
    </div>
    <div class="up-input-group">
      <div v-if="!line_chart.is_custom_x_labels">
        <up-numberinput
          v-model="line_chart.step_x_size"
          size="xs"
          label="Stepsize(X-Axis)"
          labelIcon="mdi mdi-alpha-s-box-outline"
        ></up-numberinput>
      </div>
      <div>
        <up-numberinput
          v-model="line_chart.step_y_size"
          size="xs"
          label="Stepsize(Y-Axis)"
          labelIcon="mdi mdi-alpha-y-box-outline"
        ></up-numberinput>
      </div>
      <div>
        <up-textinput
          v-model="line_chart.line_border_color"
          size="md"
          label="Border Color"
          labelIcon="mdi mdi-alpha-b-box-outline"
        ></up-textinput>
      </div>
      <div>
        <up-numberinput
          v-model="line_chart.point_radius"
          size="xs"
          label="Point Radius"
          labelIcon="mdi mdi-alpha-p-box-outline"
        ></up-numberinput>
      </div>
    </div>
    <div class="up-input-group">
      <div class="">
        <up-switch
          v-model="line_chart.is_title_bold"
          label="Is Title Bold"
          labelIcon="mdi mdi-alpha-t-box-outline"
        ></up-switch>
      </div>
      <div class="">
         <up-switch
          v-model="line_chart.is_show_lines"
          label="Is Show Lines"
          labelIcon="mdi mdi-alpha-l-box-outline"
        ></up-switch>
      </div>
      <div class="">
         <up-switch
          v-model="line_chart.is_user_select_points"
          label="Is Points Selectable"
          labelIcon="mdi mdi-alpha-p-box-outline"
        ></up-switch>
      </div>
      <div class="">
         <up-switch
          v-model="line_chart.is_allow_single_selection"
          label="Is Allow Single Selection"
          labelIcon="mdi mdi-alpha-p-box-outline"
        ></up-switch>
      </div>
      
      <div class="3">
         <up-switch
          v-model="line_chart.is_legend"
          label="Is Legend"
          labelIcon="mdi mdi-alpha-l-box-outline"
        ></up-switch>
      </div>
      <div class="">
         <up-switch
          v-model="line_chart.is_curved"
          label="Is Curved"
          labelIcon="mdi mdi-alpha-c-box-outline"
        ></up-switch>
      </div>
    </div>
    
    <div class="column is-12">
      <p class="title is-5">
        Points
        <b-button
          @click="addRow"
          type="is-success"
          size="is-small"
          icon-left="plus"
        ></b-button>
      </p>
      <b-collapse
        class="card"
        animation="slide"
        v-for="(point, index) of line_chart.properties"
        :key="`Line${index}`"
        :open="isLineOpen == index"
        @open="isLineOpen = index"
      >
        <template #trigger="props">
          <div class="card-header" role="button">
            <p class="card-header-title">{{ `Point ${index + 1}` }}</p>
            <a class="card-header-icon">
              <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
            </a>
          </div>
        </template>
        <div class="card-content">
          <div class="content">
            <b-button
              type="is-info"
              size="is-small"
              @click="
                toggle_custom_layout_cl_drawer = !toggle_custom_layout_cl_drawer
              "
              >Toggle Clipart Drawer
            </b-button>
            <clipart-selector
              v-if="toggle_custom_layout_cl_drawer"
              v-model="line_chart.properties[index].clipart"
              @input="addClipartFromDrawer"
            ></clipart-selector>
            <div class="up-input-group">
              <div>
                <up-textinput
                  v-model="point.title"
                  size="sm"
                  label="Title"
                  labelIcon="mdi mdi-alpha-t-box-outline"
                ></up-textinput>
              </div>
              <div>
                <up-textinput
                  v-model="point.x_coordinate"
                  size="xs"
                  label="X Coordinate"
                  labelIcon="mdi mdi-alpha-x-box-outline"
                ></up-textinput>
              </div>
              <div>
                <up-numberinput
                  v-model="point.y_coordinate"
                  size="xs"
                  label="Y Coordinate"
                  labelIcon="mdi mdi-alpha-y-box-outline"
                ></up-numberinput>
              </div>
            </div>
            <b-button
              @click="removeRow(index)"
              type="is-danger"
              size="is-small"
              icon-left="close"
            ></b-button>
          </div>
        </div>
      </b-collapse>
    </div>
    <div v-if="line_chart.is_user_select_points" class="column is-6">
      <p class="title is-5">
        Answers
        <b-button
          @click="addAnswerRow"
          type="is-success"
          size="is-small"
          icon-left="plus"
        ></b-button>
      </p>
      <b-table
        v-if="line_chart.selectable_answers"
        :data="line_chart.selectable_answers"
      >
        <b-table-column field="x" label="X-Coordinate" v-slot="props">
          <up-textinput v-model="props.row.x" ></up-textinput>
        </b-table-column>
        <b-table-column field="y" label="Y-Coordinate" v-slot="props">
          <up-textinput v-model="props.row.y" label="" labelIcon=""></up-textinput>
        </b-table-column>
        <b-table-column field="action" label="Action" v-slot="props">
          <b-button
            @click="removeAnswerRow(props.index)"
            size="is-small"
            type="is-danger"
            icon-left="close"
          ></b-button>
        </b-table-column>
      </b-table>
    </div>
    <div class="column is-12">
      <!-- <show-line-chart :line_chart="line_chart"></show-line-chart>
      {{ line_chart }} -->
    </div>
  </div>
</template>

<script>
import ClipartSelector from "../Clipart/ClipartSelector.vue";
// import ShowLineChart from "./ShowLineChart.vue";
import { defaultLineChartValue } from "./utils";

import UpTextinput from "@/components/UI/Inputs/UpTextinput";
import UpNumberinput from "@/components/UI/Inputs/UpNumberinput";
// import UpLabel from "@/components/UI/Label";
import UpSwitch from "@/components/UI/Inputs/UpSwitch";
export default {
  name: "set-line-chart",
  props: {
    value: {
      type: Object,
    }, // Here value = new_question.line_chart
  },
  components: {
    ClipartSelector,
    // ShowLineChart,
    UpTextinput,
    UpNumberinput,
    // UpLabel,
    UpSwitch

  },
  data() {
    return {
      isLineOpen: null,
      line_chart: this.value ? this.value : defaultLineChartValue(),
      toggle_custom_layout_cl_drawer: false,
    };
  },
  methods: {
    addRow() {
      this.line_chart.properties.push({
        x_coordinate: null,
        y_coordinate: null,
        clipart: null,
        title: "",
      });
    },
    removeRow(index) {
      this.line_chart.properties.splice(index, 1);
    },
    addClipartFromDrawer() {
      this.$buefy.toast.open({
        message: "Added clipart to LineChart",
        type: "is-success",
      });
    },
    addAnswerRow() {
      this.line_chart.selectable_answers.push({
        x: null,
        y: null,
      });
    },
    removeAnswerRow(index) {
      this.line_chart.selectable_answers.splice(index, 1);
    },
  },
  watch: {
    line_chart: {
      handler: function(new_val) {
        this.$emit("input", new_val);
      },
      deep: true,
    },
    value: {
      handler: function(new_val) {
        this.line_chart = new_val;
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
